<template>
  <PageHeader title="Account"> </PageHeader>
  <NotificationMessage :scope="$options.name"></NotificationMessage>

  <ThePage customWidthClass="tw-max-w-4xl tw-w-full">
    <BlockStack :gap="800" customWidthClass="tw-w-full tw-mx-auto">
      <PageSection> <UserProfile> </UserProfile></PageSection>

      <template v-if="this.isBoldXchangeAdmin || this.isGiftingLead">
        <PageSection>
          <StripeDefaultPaymentCard></StripeDefaultPaymentCard>
          <SubscriptionsHistoryList></SubscriptionsHistoryList>
        </PageSection>
      </template>
    </BlockStack>
  </ThePage>
</template>

<script>
import SubscriptionsHistoryList from "../../components-v2/subscriptions/SubscriptionsHistoryList";
import StripeDefaultPaymentCard from "../../components-v2/stripe/payments/StripeDefaultPaymentCard.vue";
import PageHeader from "../../components-v2/ui/layout/PageHeader";
import ThePage from "../../components-v2/ui/layout/ThePage";
import BlockStack from "../../components-v2/ui/layout/BlockStack";
import PageSection from "../../components-v2/ui/layout/PageSection";
import UserProfile from "../../components-v2/account/UserProfile";
import NotificationMessage from "../../components-v2/ui/feedback/NotificationMessage.vue";

export default {
  name: "AccountSettings",
  components: {
    NotificationMessage,
    UserProfile,
    SubscriptionsHistoryList,
    StripeDefaultPaymentCard,
    PageHeader,
    ThePage,
    BlockStack,
    PageSection,
  },
  data() {
    return {
      selectedUser: {},
      clientName: "",
      isLoading: true,
      totalSalesCount: 0,
      totalGiftsDelivered: 0,
      totalVendorsSupported: 0,
      paymentInformation: {},
      subscription: {},
      showModal: false,
      isEditingFullName: false,
      hasDefaultPaymentMethod: false,
    };
  },
  computed: {
    User() {
      return this?.$store?.state?.auth?.user;
    },
    userFullName() {
      return (
        this?.$store?.state?.auth?.user?.firstName +
        " " +
        this?.$store?.state?.auth?.user?.lastName
      );
    },
    userEmail() {
      return this?.$store?.state?.auth?.user?.email;
    },
    userCompany() {
      return this?.$store?.state?.auth?.user?.client?.name;
    },
    /** subscription info */
    subscriptionName() {
      return this?.subscription?.name;
    },

    /** payment info */
    paymentCardBrand() {
      return this?.paymentInformation?.card?.display_brand;
    },
    paymentCardLastFourDigits() {
      return this?.paymentInformation?.card?.last4;
    },
    paymentCardExpirationDate() {
      return (
        this?.paymentInformation?.card?.exp_month +
        " / " +
        this?.paymentInformation?.card?.exp_year
      );
    },
    paymentMethodButtonClass() {
      return this.hasDefaultPaymentMethod ? "primary" : "critical";
    },
  },
  methods: {
    toggleRedemptionsNotifications() {
      this.receiveRedemptionsNotifications =
        !this.receiveRedemptionsNotifications;
    },
    toggleClicksNotifications() {
      this.receiveClicksNotifications = !this.receiveClicksNotifications;
    },
  },
};
</script>

<style scoped></style>
